import { render, staticRenderFns } from "./FreeBlindboxSection.vue?vue&type=template&id=fd428c6c&scoped=true"
import script from "./FreeBlindboxSection.vue?vue&type=script&lang=js"
export * from "./FreeBlindboxSection.vue?vue&type=script&lang=js"
import style0 from "./FreeBlindboxSection.vue?vue&type=style&index=0&id=fd428c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd428c6c",
  null
  
)

export default component.exports